<template>
  <div>
    <v-app-bar flat color="white" class="x-scroll">
      <div class="pa-2">
        <v-btn class="gray font-weight-bold" @click="onBack"
          ><v-icon left>mdi-arrow-left-circle</v-icon>戻る</v-btn
        >
      </div>
      <div class="pa-2">
        <v-btn class="info font-weight-bold" @click="onHistory"
          ><v-icon left>mdi-comment-text-outline</v-icon>履歴参照</v-btn
        >
      </div>
      <v-spacer></v-spacer>
      <div class="pa-2"></div>
    </v-app-bar>
  </div>
</template>

<script>
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  props: ["type", "cast_id"],
  setup(props, ctx) {
    const onBack = async () => {
      ctx.emit("on_back");
    };
    const onHistory = async () => {
      ctx.emit("on_history");
    };

    return {
      props,
      onBack,
      onHistory,
    };
  },
});
</script>
